// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/utils.scss");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
exports.push([module.id, "._5sJtSbnSx{display:block;width:100%;box-sizing:border-box}._5sJtSbnSx:link{text-decoration:none}[data-panel-position=secondary] ._5sJtSbnSx,[data-panel-position=hidden] ._5sJtSbnSx{background-color:unset;padding:unset;box-shadow:unset}.RT7vUQYLx{}._15KxxJDxx{}._625CoVGhx{}._6dNIBX5mx.krhTRqZvx{padding-top:0}.oe93h2KMx{}@media (max-width: 767px){html[data-supports-mobile=true] .oe93h2KMx{padding:16px}}._5RYKG3jbx{padding:32px}@media (min-width: 1300px){._5RYKG3jbx{padding:32px}}@media (min-width: 1500px){._5RYKG3jbx{padding:32px}}@media (max-width: 767px){html[data-supports-mobile=true] ._5RYKG3jbx{padding:16px}html[data-supports-mobile=true] ._5RYKG3jbx.krhTRqZvx{padding-top:0}}._4QcUqziSx{padding:20px}@media (min-width: 1300px){._4QcUqziSx{padding:32px}}@media (min-width: 1500px){._4QcUqziSx{padding:32px}}@media (max-width: 767px){html[data-supports-mobile=true] ._4QcUqziSx{padding:16px}html[data-supports-mobile=true] ._4QcUqziSx.krhTRqZvx{padding-top:0}}._6I4ueHL5x{padding-top:0}._5GWzXvXXx{display:flex;justify-content:center;padding-top:20px}._4FHRj32Ux{background-color:var(--surface-card)}._3vufMmqGx{background-color:var(--gray-background)}.vwmnLbrLx{box-shadow:inset 0 0 0 1px rgba(0,0,0,0.06)}._6tqQ8rWSx{box-shadow:0 3px 6px rgba(0,0,0,0.06)}.jtNEu5HWx{box-shadow:0 3px 6px rgba(0,0,0,0.06),inset 0 0 0 1px rgba(0,0,0,0.06)}._1lKsjj0qx{box-shadow:0 3px 6px rgba(0,0,0,0.12)}._33wSZHv8x{box-shadow:0 3px 6px rgba(0,0,0,0.12),inset 0 0 0 1px rgba(0,0,0,0.06)}._6hySX6VBx{box-shadow:0 0 32px rgba(0,0,0,0.06)}._4TEr8tVcx{box-shadow:0 6px 12px rgba(0,0,0,0.06)}._2fZ9DelOx{box-shadow:0 12px 32px rgba(0,0,0,0.12)}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"block": "_5sJtSbnSx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["paragraph-m"] + "",
	"border-radius-small": "RT7vUQYLx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["rounded-sm"] + "",
	"borderRadiusSmall": "RT7vUQYLx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["rounded-sm"] + "",
	"border-radius-medium": "_15KxxJDxx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["rounded-m"] + "",
	"borderRadiusMedium": "_15KxxJDxx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["rounded-m"] + "",
	"border-radius-large": "_625CoVGhx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["rounded-lg"] + "",
	"borderRadiusLarge": "_625CoVGhx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["rounded-lg"] + "",
	"block-padding": "_6dNIBX5mx",
	"blockPadding": "_6dNIBX5mx",
	"flush": "krhTRqZvx",
	"padding-default": "oe93h2KMx _6dNIBX5mx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["padding-m"] + "",
	"paddingDefault": "oe93h2KMx _6dNIBX5mx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["padding-m"] + "",
	"padding-panel": "_5RYKG3jbx _6dNIBX5mx",
	"paddingPanel": "_5RYKG3jbx _6dNIBX5mx",
	"padding-modal": "_4QcUqziSx _6dNIBX5mx",
	"paddingModal": "_4QcUqziSx _6dNIBX5mx",
	"with-header": "_6I4ueHL5x",
	"withHeader": "_6I4ueHL5x",
	"hero": "_5GWzXvXXx",
	"background-white": "_4FHRj32Ux",
	"backgroundWhite": "_4FHRj32Ux",
	"background-gray": "_3vufMmqGx",
	"backgroundGray": "_3vufMmqGx",
	"shadow-none-bordered": "vwmnLbrLx",
	"shadowNoneBordered": "vwmnLbrLx",
	"shadow-card-subtle": "_6tqQ8rWSx",
	"shadowCardSubtle": "_6tqQ8rWSx",
	"shadow-card-subtle-bordered": "jtNEu5HWx",
	"shadowCardSubtleBordered": "jtNEu5HWx",
	"shadow-card-intense": "_1lKsjj0qx",
	"shadowCardIntense": "_1lKsjj0qx",
	"shadow-card-intense-bordered": "_33wSZHv8x",
	"shadowCardIntenseBordered": "_33wSZHv8x",
	"shadow-overlay-subtle": "_6hySX6VBx",
	"shadowOverlaySubtle": "_6hySX6VBx",
	"shadow-overlay-medium": "_4TEr8tVcx",
	"shadowOverlayMedium": "_4TEr8tVcx",
	"shadow-overlay-intense": "_2fZ9DelOx",
	"shadowOverlayIntense": "_2fZ9DelOx"
};
module.exports = exports;
